import cn from 'classnames';
import React from 'react';

import {LoadingLight} from '@/components/Icons';

import ButtonRaw from '../ButtonRaw';
import styles from './AppButton.module.scss';

const AppButton = (props) => {
    const {
        className,
        primary,
        secondary,
        tertiary,
        tertiaryNoUnderline,
        tertiaryNoActive,
        quaternary,
        light,
        dark,
        darkV2,
        colored,
        disabled,
        loading,
        children,
        to,
        raw,
        ...rest
    } = props;
    const classes = cn(
        {[styles.Button]: !tertiary && !tertiaryNoUnderline && !raw},
        {
            [styles.Loading]: loading && !disabled,
            [styles.PrimaryLight]: primary && light && !disabled,
            [styles.SecondaryLight]: secondary && light && !disabled,
            [styles.PrimaryDark]: primary && dark && !disabled,
            [styles.SecondaryDark]: secondary && dark && !disabled,
            [styles.SecondaryDarkV2]: secondary && darkV2 && !disabled,
            [styles.Quaternary]: quaternary && !disabled,
            [styles.Light]: light && !disabled,
            [styles.Dark]: dark && !disabled,
            [styles.TertiaryBasic]: tertiary || tertiaryNoUnderline,
            [styles.Tertiary]: tertiary && !tertiaryNoUnderline && !loading,
            [styles.TertiaryActive]: tertiary && !disabled && !tertiaryNoUnderline && !loading && !tertiaryNoActive,
            [styles.TertiaryLoading]: tertiary && loading,
            [styles.TertiaryDisabled]: tertiary && disabled,
            [styles.Active]: !disabled && !tertiary && (primary || secondary),
            [styles.Disabled]: disabled,
            [styles.PrimaryColored]: primary && colored && !disabled,
            [styles.SecondaryColored]: secondary && colored && !disabled,
            [styles.SecondaryColoredLight]: secondary && colored && light && !disabled,
        },
        className
    );

    return (
        <ButtonRaw className={classes} disabled={disabled || loading} to={to} {...rest}>
            <div className={cn({'opacity-0': loading})}>{children}</div>
            {loading && <LoadingLight className={styles.Loader} />}
        </ButtonRaw>
    );
};

export default AppButton;
